AGADash.Repository = (function () {
    var registers = {};
    var panelRender = null;
    var panelTools = null;

    var register = function (kind, implementor) { registers[kind] = implementor; };

    var find = function (kind) { return registers[kind]; };

    var setPanelRender = function (obj) { panelRender = obj; };
    var getPanelRender = function () { return panelRender; };

    var setPanelTools = function (obj) { panelTools = obj; };
    var getPanelTools = function () { return panelTools; };


    return {
        register: register,
        find: find,

        setPanelRender: setPanelRender,
        getPanelRender: getPanelRender,

        setPanelTools: setPanelTools,
        getPanelTools: getPanelTools

    };

})();